import React from "react";
import { Person } from "@material-ui/icons";
import { TextField } from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../SearchPage/_redux/searchRedux";
import { Select } from "antd";
import { Button } from "@material-ui/core";
import isValidIranianNationalCode from "../../../../../../functions/nationalCodeValidation";

const { Option } = Select;

const authSchema = Yup.object().shape({
  firstName: Yup.string().required(),
  lastName: Yup.string().required(),
  gender: Yup.string().required(),
});

const PassengersField = (props) => {
  let { state } = useSelector((state) => ({
    state: state.search,
  }));

  const [isValidForms, setIsValidForms] = React.useState(false);
  const [isNationalCode, setIsNationalCode] = React.useState(false);

  React.useEffect(() => {
    if (isValidForms && isNationalCode) {
      const copyValidates = props.validates;
      copyValidates[props.id] = true;
      props.setValidates(copyValidates);
    } else {
      const copyValidates = props.validates;
      copyValidates[props.id] = false;
      props.setValidates(copyValidates);
    }
  });

  const dispatch = useDispatch();
  return (
    <div className="d-flex flex-column">
      <div className="d-flex align-items-center justify-content-between">
        <h4>
          <b>مسافر</b>
        </h4>
        <Button
          onClick={() => {
            props.ValueIdSetter(props.id);
            props.handleClickOpen();
          }}
        >
          <span
            class="badge badge-secondary d-flex align-items-center"
            style={{ borderRadius: "10rem", gap: "8px", height: "40px" }}
          >
            <Person style={{ color: "#6dd06d" }} />
            <h6 className="mx-auto my-auto">مسافرین منتخب</h6>
          </span>
        </Button>
      </div>
      <div
        className="my-5 d-block d-md-flex"
        style={{ display: `${props.dis}` }}
      >
        {state.fullSeats[props.id] && !props.isFavEntered ? (
          <Formik
            enableReinitialize
            validationSchema={authSchema}
            validateOnBlur={true}
            validateOnMount={true}
            validateOnChange={true}
            validate={true}
            initialValues={
              state.fullSeats[props.id] ? state.fullSeats[props.id] : {}
            }
          >
            {({ isValid, setFieldValue, touched, errors, values }) => {
              setIsValidForms(isValid);
              setIsNationalCode(
                isValidIranianNationalCode(values.nationalCode)
              );

              return (
                <>
                  <div
                    className="col-sm-12 col-md-3"
                    style={{ marginBlock: "1.65rem" }}
                  >
                    <TextField
                      id="outlined-basic"
                      placeholder="نام"
                      variant="outlined"
                      value={
                        state.fullSeats[props.id].firstName
                          ? state.fullSeats[props.id].firstName
                          : null
                      }
                      className="w-100"
                      onChange={(e) => {
                        setFieldValue("firstName", e.target.value);
                        let copy = state.fullSeats;
                        copy[props.id].firstName = e.target.value;
                        dispatch(actions.setFullSeats(copy));
                      }}
                    />
                    {errors.firstName ? (
                      <h5 className="mt-2">{touched.firstName}</h5>
                    ) : null}
                  </div>
                  <div
                    className="col-sm-12 col-md-3"
                    style={{ marginBlock: "1.65rem" }}
                  >
                    <TextField
                      id="outlined-basic"
                      placeholder="نام خانوادگی"
                      variant="outlined"
                      className="w-100"
                      value={
                        state.fullSeats[props.id].lastName
                          ? state.fullSeats[props.id].lastName
                          : null
                      }
                      onChange={(e) => {
                        setFieldValue("lastName", e.target.value);
                        let copy = state.fullSeats;
                        copy[props.id].lastName = e.target.value;
                        dispatch(actions.setFullSeats(copy));
                      }}
                    />
                    {errors.lastName ? (
                      <h5 className="mt-2">{touched.lastName}</h5>
                    ) : null}
                  </div>{" "}
                  <div
                    className="col-sm-12 col-md-3"
                    style={{ marginBlock: "1.65rem" }}
                  >
                    <TextField
                      id="outlined-basic"
                      placeholder="کد ملی"
                      variant="outlined"
                      type="number"
                      className="w-100"
                      value={
                        state.fullSeats[props.id].nationalCode
                          ? state.fullSeats[props.id].nationalCode
                          : null
                      }
                      onChange={(e) => {
                        setFieldValue("nationalCode", e.target.value);
                        let copy = state.fullSeats;
                        copy[props.id].nationalCode = e.target.value;
                        dispatch(actions.setFullSeats(copy));
                        const isNationalCodeValid = isValidIranianNationalCode(
                          e.target.value
                        );
                        if (isNationalCodeValid) {
                          setIsNationalCode(true);
                        } else {
                          setIsNationalCode(false);
                        }
                      }}
                    />
                    {errors.nationalCode ? (
                      <h5 className="mt-2">{touched.nationalCode}</h5>
                    ) : null}
                  </div>
                  <div
                    className="col-sm-12 col-md-3 "
                    style={{ height: "4.3rem", marginBlock: "1.65rem" }}
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      style={{ borderRadius: "13px" }}
                      className="w-100 h-100"
                      value={state.fullSeats[props.id]?.gender}
                      onSelect={(e) => {
                        setFieldValue("gender", e);
                        let copy = state.fullSeats;
                        copy[props.id].gender = e;
                        dispatch(actions.setFullSeats(copy));
                      }}
                      placeholder={
                        <span
                          className="d-flex align-items-center"
                          style={{ gap: "5px" }}
                        >
                          <h5 className="mx-auto my-auto text-muted">جنسیت</h5>
                        </span>
                      }
                    >
                      <Option
                        className="d-flex align-items-center"
                        value={null}
                      >
                        جنسیت را انتخاب کنید
                      </Option>
                      <Option
                        className="d-flex align-items-center"
                        style={{ gap: "13px" }}
                        value={1}
                      >
                        <i
                          className="fa fa-male"
                          style={{
                            fontSize: 20,
                            color: "#6dd06d",
                          }}
                        ></i>{" "}
                        <span style={{ fontSize: "12px" }}>آقا</span>
                      </Option>
                      <Option
                        className="d-flex align-items-center"
                        style={{ gap: "13px" }}
                        value={0}
                      >
                        <i
                          className="fa fa-female"
                          style={{
                            fontSize: 20,
                            color: "#6dd06d",
                          }}
                        ></i>{" "}
                        <span style={{ fontSize: "12px" }}> خانم</span>
                      </Option>

                      {/* <Option
                        className="d-flex align-items-center"
                        style={{ gap: "13px" }}
                        value={2}
                      >
                        <i
                          className="fa fa-child"
                          style={{
                            fontSize: 15,
                            color: "#6dd06d",
                          }}
                        ></i>{" "}
                        <span style={{ fontSize: "12px" }}> کودک</span>
                      </Option> */}
                    </Select>
                  </div>
                </>
              );
            }}
          </Formik>
        ) : null}
      </div>
    </div>
  );
};

export default PassengersField;
